import axios from "axios";
import { T, APIS } from "../../Constants";

const { ICONS_API } = APIS;

type GetIcon = T.API.ToAxios<T.API.Utils.Icons.GetIcon>;

/** Generate a list of equipments, and some useful properties translations, for an excel EDL */
export const getIcon: GetIcon = name => axios.get(ICONS_API + "name", { params: { name } });